import Navbar from '../components/header/Navbar';
import KoalaSection from '../components/home/KoalaSection';
import Footer from '../components/Footer';
import Facts from '../components/home/Facts';
import Map from '../components/home/HomePageMap';
import Gallery from '../components/home/HomePageGallery';
import AboutUs from '../components/home/AboutUs';

export default function HomePage() {
  return (
    <>
      <Navbar /> {/* Top navbar */}
      <KoalaSection /> {/* Koala section */}
      <Facts />
      <Gallery />
      <Map />
      <AboutUs />
      <Footer /> {/* Footer */}
    </>
  );
}